import { ThunkHelper } from 'invision-core';
export var CLEAR_DISCOUNT_FORM = 'CLEAR_DISCOUNT_FORM';
export var clearDiscountForm = function clearDiscountForm() {
  return {
    type: SET_DISCOUNT_FORM,
    payload: {}
  };
};
export var SET_DISCOUNT_FORM = 'SET_DISCOUNT_FORM';
export var setDiscountForm = function setDiscountForm(form) {
  return {
    type: SET_DISCOUNT_FORM,
    payload: form
  };
};
export var RETRIEVE_DISCOUNT_CONTEXT = {
  BEGIN: 'RETRIEVE_DISCOUNT_CONTEXT_BEGIN',
  SUCCESS: 'RETRIEVE_DISCOUNT_CONTEXT_SUCCESS',
  FAILURE: 'RETRIEVE_DISCOUNT_CONTEXT_FAILURE'
};
var RETRIEVE_DISCOUNT_CONTEXT_TYPES = [RETRIEVE_DISCOUNT_CONTEXT.BEGIN, RETRIEVE_DISCOUNT_CONTEXT.SUCCESS, RETRIEVE_DISCOUNT_CONTEXT.FAILURE];
export var CLEAR_DISCOUNT_CONTEXT = 'CLEAR_DISCOUNT_CONTEXT';
export var clearDiscountContext = function clearDiscountContext() {
  return {
    type: CLEAR_DISCOUNT_CONTEXT
  };
};

/**
 * Retrieves qualified discounts for ITV subscription maintenance / order flows.
 * Prefer this over bulk DiscretionaryDiscounts metadata when effective-date filtering is required.
 *
 * @param {Object} request
 * @param {string} [request.Currency]
 * @param {boolean} [request.ExcludeRegular]
 * @param {boolean} [request.ExcludeDiscretionary]
 * @param {boolean} [request.ExcludeGlobal]
 */
export var retrieveDiscountContext = function retrieveDiscountContext() {
  var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (dispatch) {
    return ThunkHelper(dispatch, RETRIEVE_DISCOUNT_CONTEXT_TYPES, {
      method: 'post',
      url: 'SubscriberManagement/RetrieveDiscountContext',
      data: request
    });
  };
};